import { render, staticRenderFns } from "./LearningCardEditor.vue?vue&type=template&id=39069dae&scoped=true"
import script from "./LearningCardEditor.vue?vue&type=script&lang=js"
export * from "./LearningCardEditor.vue?vue&type=script&lang=js"
import style0 from "./LearningCardEditor.vue?vue&type=style&index=0&id=39069dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39069dae",
  null
  
)

export default component.exports